import React, { Component } from 'react';
import commonUtil from '../../../utils/commonUtil';
import RadioButton from '../../../components/ZUILib/RadioButton';
import _ from 'lodash';
import { browserHistory } from 'react-router';
import SelectionTab from '../../../components/ZUILib/SelectionTab';
import MultiSelectDropdown from '../../../components/MultiSelectDropdown';
import { UIBrands2 } from '../../../utils/clientConstant';

const applicationRoutes = commonUtil.getApplicationRoutes();

class GiftListTableFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: '',
      selectedStore: '',
      selectedBonus: '',
      onFilterDropDown: true,
      onMesdecompraDropDown: true,
      onTiendasDropDown: true,
      onBonificacionDropDown: true,
    };

    this.eventId = this.props.eventId;
    this.eventInfo = this.props.eventInfo;
    this.isViewAll = false;
    this.currentPage = 1;
  }

  componentDidMount(){

  }

  handleOptionChange = (selectedData, event) => {
    this.setState({ selectedOption: selectedData.value });
    this.updateFilterParams('date', selectedData.value,);
  };

  handleStoreChange = (selectedData, event) => {
    this.setState({ selectedStore: selectedData.value });
    this.updateFilterParams('store', selectedData.value,);
  };

  handleBonusChange = (selectedData, event) => {
    this.setState({ selectedBonus: selectedData.value });
    this.updateFilterParams('bonusApplicable', selectedData.value,);
  };  

  handleClearFilters = () => {
    this.setState({
      selectedOption: '', 
      selectedStore: '',
      selectedBonus: ''
    });
    
     this.props.getFilterSorted([], this.props.sortingParameters, this.currentPage, this.isViewAll, true);
  }

  onDropDownClick = (label) => {
    this.setState((prevState) => {
      switch (label) {
        case 'filtrar':
          return { onFilterDropDown: !prevState.onFilterDropDown };
        case 'compra':
          return { onMesdecompraDropDown: !prevState.onMesdecompraDropDown };
        case 'tiendas':
          return { onTiendasDropDown: !prevState.onTiendasDropDown };
        case 'bonificacion':
          return { onBonificacionDropDown: !prevState.onBonificacionDropDown };
        default:
          return {};
      }
    });
  };

    onFilterSortingChange = (e) => {
      /*eslint-disable*/
      const filteringParameters = this.props.filteringParameters;
      let fpType = '', isRemove = false;
      if (e.senderId === 'showEveryThingDropdown') {
        fpType = 'date';
        if (e.value === 'showAll') {
          isRemove = true;
        }
      } else if (e.senderId === 'applyForBonusDropdown') {
        fpType = 'bonusApplicable';
        if (e.value === 'allBonus') {
          isRemove = true;
        }
      }
      this.updateFilterParams(fpType, e.value, isRemove);
      /*eslint-enable*/
    }
  
    onBrandChange = (e) => {
      let isRemove = false;
      let value = '';
      if (e.length > 0) {
        for (let i = 0; i < e.length; i++) {
          if (!e[i].isAllSelector) {
            value += e[i].value + ',';
          }
        }
        value = value.substr(0, value.length - 1);
      } else {
        isRemove = true;
      }
      if (e.length && e[0].isAllSelector && e[0].isChecked) {
        isRemove = true;
      }
      this.updateFilterParams('store', value, isRemove);
    }
  
    updateFilterParams(fpType, value, isRemove) {
      const filteringParameters = this.props.filteringParameters;
      if (isRemove) {
        for (let i = 0; i < filteringParameters.length; i++) {
          if (filteringParameters[i].type === fpType) {
            filteringParameters.splice(i, 1);
          }
        }
      } else {
        const type = _.find(filteringParameters, { type: fpType });
        if (type) {
          type.value = value;
        } else {
          filteringParameters.push({ type: fpType, value });
        }
      }
      this.props.getFilterSorted(filteringParameters, this.props.sortingParameters, this.currentPage, this.isViewAll);
    }


    splitPrice = (value) => {
      const str = String(value).trim();
    
      const match = str.match(/^(\D?)([\d,]+)(?:\.(\d+))?$/);
      if (!match) {
        return {
          currency: '$',
          integerWithDot: '0.',
          decimal: '00'
        };
      };
    
      const currency = match[1] || '';
      const rawIntegerPart = match[2].replace(/,/g, '');
      const decimalPart = match[3] || '00';
    
      const formattedInt = Number(rawIntegerPart).toLocaleString();
    
      return {
        currency,
        integerWithDot: formattedInt + '.',
        decimal: decimalPart.padEnd(2, '0')
      };
    }
    

  render() {
    const {
      selectedOption,
      selectedStore,
      selectedBonus,
      onFilterDropDown,
      onMesdecompraDropDown,
      onTiendasDropDown,
      onBonificacionDropDown
    } = this.state;

    const { isPhysical,isElectronic,isPersonal, isBonusContainerVisible } = this.props;

    const CantidadText = isPhysical
            ? commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.physical.quantity.text',
            )
            : isElectronic
            ? commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.electronic.quantity.text',
            )
            : isPersonal
            ? commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.personal.product.quantity.text',
            )
            : "";
    
    const sumTotalText = isPhysical
            ? commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.physical.sum.total.text',
            )
            : isElectronic
            ? commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.electronic.sum.total.text',
            )
            : isPersonal
            ? commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.personal.sum.total.text',
            )
            : "";
    
      const keyTransformForBonus = isPhysical ? 'physicalItemInfo'
      : isElectronic ? 'electronicItemInfo'
      : isPersonal ? 'personalItemInfo'
      : '';        
  
    const purchasedItemSummaryInfoData = this.props.purchasedItemSummaryInfoData;

    const billingItemData = this.props?.statementDetailsForPrintAndDownloadData?.accountStatementInfo?.statementSummary[keyTransformForBonus]

    const bonusPercentage = this.props?.statementDetailsForPrintAndDownloadData?.accountStatementInfo?.bonusDetails?.bonusPercentage || 0;

    // const paginationInfo = this.props.purchasedItemsDetailsData && this.props.purchasedItemsDetailsData.paginationInfo ? this.props.purchasedItemsDetailsData.paginationInfo : null;

    const showEverything = {
        id: 'showEveryThingRadioBox',
        disable: false,
        defaultValue: '',
        options: [{
          value: '1',
          labelResourceId: 'Ultimo mes',
          disabled: false,
        }, {
          value: '3',
          labelResourceId: 'Ultimos 3 meses',
          disabled: false,
        }, {
          value: '6',
          labelResourceId: 'Ultimos 6 meses',
          disabled: false,
        }],
      };
  
      const allStores = {
        id: 'allStoresRadiobox',
        disable: false,
        title: commonUtil.getLabel(this.props.lables['Physical Gifts Details Page'], 'accountStatement.physical.dropdownLabel2'),
        options: [],
      };
      UIBrands2.forEach((val, index) => {
        allStores.options.push({
          id: ((allStores.id + '_rbbox_') + index),
          value: val.id,
          label: val.label,
          disabled: false,
          isChecked: false,
        });
      });
  
      const applyForBonus = {
        id: 'applyForBonusRadioBox',
        disable: false,
        defaultValue: '',
        options: [{
          value: 'true',
          labelResourceId: 'Aplica para bono',
          disabled: false,
        }, {
          value: 'false',
          labelResourceId: 'No aplica para bono',
          disabled: false,
        }],
      };

      let totalPurchasedAmount = billingItemData?.totalPurchasedAmount ? commonUtil.getCurrency(billingItemData?.totalPurchasedAmount) : '$0';
      totalPurchasedAmount = this.splitPrice(totalPurchasedAmount);

      let totalAmountEligibleForBonus = billingItemData?.totalAmountEligibleForBonus ? commonUtil.getCurrency(billingItemData?.totalAmountEligibleForBonus) : '$0';
      totalAmountEligibleForBonus = this.splitPrice(totalAmountEligibleForBonus);

      let totalBonusAmount = billingItemData?.totalBonusAmount ? commonUtil.getCurrency(billingItemData?.totalBonusAmount) : '$0';
      totalBonusAmount = this.splitPrice(totalBonusAmount);

      let totalAmountNotEligibleForBonus = billingItemData?.totalAmountNotEligibleForBonus ? commonUtil.getCurrency(billingItemData?.totalAmountNotEligibleForBonus) : '$0';
      totalAmountNotEligibleForBonus = this.splitPrice(totalAmountNotEligibleForBonus);

      const downArrowIconPath = 'M16.59 8.29492L12 12.8749L7.41 8.29492L6 9.70492L12 15.7049L18 9.70492L16.59 8.29492Z';
      const upArrowIconPath = 'M12 8.29492L6 14.2949L7.41 15.7049L12 11.1249L16.59 15.7049L18 14.2949L12 8.29492Z';

    return (
      <div className='gift-list-filter-container col-lg-3 col-xl-3 col-sm-3'>
        <div className='giftlist-breakdown-container col-lg-12 col-xl-12 col-sm-12'>
          <div className='giftlist-breakdown-box'>
            <span className='giftlist-breakdown-text'>{commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.gift.table.breakdown.text',
            )}</span>
          </div>
          <div className='giftlist-breakdown-physicalgifts-box'>
            <span className='giftlist-breakdown-physicalgifts-text'>{CantidadText}</span>
            <div className='giftlist-breakdown-physicalgifts-amount-box'>
              <span className='giftlist-breakdown-physicalgifts-amount-text'>{purchasedItemSummaryInfoData?.itemSummary?.totalPurchasedItemsCount || '0' }</span>
            </div>
          </div>
          <div className={`giftlist-physicalgiftsamount-container ${!isBonusContainerVisible && 'border-btm-none'}`}>
            <span className='giftlist-physicalgiftsamount-text'>{sumTotalText}</span>
            <div className='giftlist-physicalgiftsamount-box'>
              <span className='giftlist-physicalgiftsamount-price1'>{totalPurchasedAmount.currency} {totalPurchasedAmount.integerWithDot} </span>
              <span className='giftlist-physicalgiftsamount-price2'>{totalPurchasedAmount.decimal}</span>
            </div>
          </div>
          {isBonusContainerVisible && <>
          <div className='giftlist-generated-bonus-box'>
            <span className='giftlist-physicalgiftsamount-text'>{commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.gift.table.eligible.bonus.text',
            )}</span>
            <div className='giftlist-physicalgiftsamount-box'>
              <span className='giftlist-physicalgiftsamount-price1'>{totalAmountEligibleForBonus.currency} {totalAmountEligibleForBonus.integerWithDot} </span>
              <span className='giftlist-physicalgiftsamount-price2'>{totalAmountEligibleForBonus.decimal}</span>
            </div>
          </div>
          <div className={`giftlist-physicalgiftsamount-container ${isElectronic && 'border-btm-none'}`}>
            <span className='giftlist-physicalgiftsamount-text'>{bonusPercentage}{commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.gift.table.accumulated.bonus.text',
            )}</span>
            <div className='giftlist-physicalgiftsamount-box'>
              <span className='giftlist-accumulated-bonusamount-box'>{totalBonusAmount.currency} {totalBonusAmount.integerWithDot} </span>
              <span className='giftlist-accumulated-bonusamount-box2'>{totalBonusAmount.decimal}</span>
            </div>
          </div>
          {!isElectronic &&
          <div className='giftlist-generated-bonus-box'>
            <span className='giftlist-physicalgiftsamount-text'>{commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.gift.table.not.eligible.bonus.text',
            )}</span>
            <div className='giftlist-physicalgiftsamount-box'>
              <span className='giftlist-physicalgiftsamount-price1'>{totalAmountNotEligibleForBonus.currency} {totalAmountNotEligibleForBonus.integerWithDot} </span>
              <span className='giftlist-physicalgiftsamount-price2'>{totalAmountNotEligibleForBonus.decimal}</span>
            </div>
          </div>}
          </>}
        </div>

        {purchasedItemSummaryInfoData?.itemSummary?.totalPurchasedItemsCount > 0 && 
          <div className='giftlist-filters-container col-lg-12 col-xl-12 col-sm-12'>
          <div className='giftlist-filters-box'>
            <div className='giftlist-filter'>
              {
                this.props.filteringParameters && this.props.filteringParameters.length > 0 ?
                <>
                <span className='giftlist-filter-text'>{commonUtil.getLabel(this.props.lables.eventAccountStatement,'accountStatement.gift.table.filter.items.text',)} ({this.props.filteringParameters.length})</span>
                <span onClick={this.handleClearFilters} className='giftlist-clear-filters-text'>{commonUtil.getLabel(this.props.lables.eventAccountStatement,'accountStatement.gift.table.clean.filters.text',)}</span>
                </>:
                <>
                <span className='giftlist-filter-text'>
                {
                  commonUtil.getLabel(this.props.lables.eventAccountStatement,'accountStatement.gift.table.filter.text',)
                }
                </span>
              <svg onClick={() => this.onDropDownClick("filtrar")} className="cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                <path d={`${onFilterDropDown ? upArrowIconPath : downArrowIconPath}`} fill="#333333" />
              </svg>
                </>
              }
              
            </div>
          </div>

          {onFilterDropDown && <>
            {/* Mes de compra */}
            <div className={`giftlist-filter-mesdecompra-container ${onMesdecompraDropDown ? 'giftlist-filter-mesdecompra-container-open' : ''}`}>
              <div className='giftlist-filter-mesdecompra-box'>
                <div className='giftlist-filter-mesdecompra-heading'>
                  <span className='giftlist-filter-mesdecompra-text'>{commonUtil.getLabel(
                      this.props.lables.eventAccountStatement,
                      'accountStatement.gift.table.purchase.month.text',
                    )}</span>
                </div>
                <svg onClick={() => this.onDropDownClick("compra")} className="cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                  <path d={`${onMesdecompraDropDown ? upArrowIconPath : downArrowIconPath}`} fill="#333333" />
                </svg>
              </div>

              {onMesdecompraDropDown && (
                <div className='giftlist-filter-mesdecompra-items-box'>
                  {showEverything.options.map((option, index) => (
                    <div key={index} className='giftlist-filter-mesdecompra-item-box radioGL'>
                      <RadioButton
                        key={index}
                        displayName={option.labelResourceId}
                        id={`option${index}`}
                        value={option.value}
                        title={option.labelResourceId}
                        checked={(option.value == selectedOption)}
                        radioCssClass={"radio"}
                        name={showEverything.id}
                        onChangeFunction={this.handleOptionChange}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Tiendas */}
            <div className={`giftlist-filter-mesdecompra-container ${onTiendasDropDown ? 'giftlist-filter-mesdecompra-container-open' : ''}`}>
              <div className='giftlist-filter-mesdecompra-box'>
                <div className='giftlist-filter-mesdecompra-heading'>
                  <span className='giftlist-filter-mesdecompra-text'>{commonUtil.getLabel(
                      this.props.lables.eventAccountStatement,
                      'accountStatement.gift.table.store.text',
                    )}</span>
                </div>
                <svg onClick={() => this.onDropDownClick("tiendas")} className="cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                  <path d={`${onTiendasDropDown ? upArrowIconPath : downArrowIconPath}`} fill="#333333" />
                </svg>
              </div>

              {onTiendasDropDown && (
                <div className='giftlist-filter-mesdecompra-items-box'>
                  {allStores.options.map((store, index) => (
                    <div key={index} className='giftlist-filter-mesdecompra-item-box radioGL'>
                      <RadioButton
                        key={index}
                        displayName={store.label}
                        id={store.id}
                        value={store.value}
                        title={store.label}
                        checked={(store.value == selectedStore)}
                        radioCssClass={"radio"}
                        name={'Tiendas'}
                        onChangeFunction={this.handleStoreChange}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Bonificación */}
            { (isBonusContainerVisible && !isElectronic) &&
            <div className={`giftlist-filter-mesdecompra-container ${onBonificacionDropDown ? 'giftlist-filter-mesdecompra-container-open' : ''}`}>
              <div className='giftlist-filter-mesdecompra-box'>
                <div className='giftlist-filter-mesdecompra-heading'>
                  <span className='giftlist-filter-mesdecompra-text'>{commonUtil.getLabel(
                      this.props.lables.eventAccountStatement,
                      'accountStatement.summary.bonus.heading',
                    )}</span>
                </div>
                <svg onClick={() => this.onDropDownClick("bonificacion")} className="cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                  <path d={`${onBonificacionDropDown ? upArrowIconPath : downArrowIconPath}`} fill="#333333" />
                </svg>
              </div>

              {onBonificacionDropDown && (
                <div className='giftlist-filter-mesdecompra-items-box'>
                  {applyForBonus.options.map((bonus, index) => (
                    <div key={index} className='giftlist-filter-mesdecompra-item-box radioGL'>
                      <RadioButton
                        key={index}
                        displayName={bonus.labelResourceId}
                        id={`bonus${index}`}
                        value={bonus.value}
                        title={bonus.labelResourceId}
                        checked={(bonus.value == selectedBonus)}
                        radioCssClass={"radio"}
                        name={applyForBonus.id}
                        onChangeFunction={this.handleBonusChange}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>}
          </>}
        </div>
        }
        
      </div>
    );
  }
}

export default GiftListTableFilters;
